export default __webpack_public_path__ + "static/ForgetSectionRight_us-3c5f19f106b9e4415aecb74ff31af8d5.png";